<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Cierre de Comisiones</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button v-show="!comprobantesConsultados" @click="consultar" class="btn-info btn--bigger">
            <i class="fa fa-search"></i>
            <span>Consultar</span>
          </button>
          <button v-show="comprobantesConsultados" @click="cancelar" class="btn-danger btn--bigger">
            <i class="fa fa-ban"></i>
            <span>Cancelar</span>
          </button>
          <button v-show="comprobantesConsultados" @click="cerrar" class="btn-success btn--bigger">
            <i class="fa fa-times"></i>
            <span>Cerrar</span>
          </button>
          <button @click="consultarCierres" class="btn-primary btn--bigger">
            <i class="fa fa-table"></i><span>Consultar cierres de conciliación</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h3>Información de cierre</h3>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <date-picker
                  :disabled="comprobantesConsultados"
                  v-model="form.fecha_inicial"
                  type="date"
                  format="dd-MM-yyyy"
                  id="fecha_inicial"
                ></date-picker>
                <label>Fecha inicial</label>
                <span v-if="errores.fecha_inicial" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.fecha_inicial[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <date-picker
                  :disabled="comprobantesConsultados"
                  v-model="form.fecha_final"
                  type="date"
                  format="dd-MM-yyyy"
                  id="fecha_final"
                ></date-picker>
                <label>Fecha final</label>
                <span v-if="errores.fecha_final" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.fecha_final[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div
              class="form-field select2"
              :class="{
              'select2--disabled' : comprobantesConsultados
            }"
            >
              <div class="select2-field">
                <v-select
                  @input="inputVendedores"
                  placeholder="Seleccione los vendedores..."
                  id="vendedores"
                  v-model="selectedVendedores"
                  :options="vendedores"
                  label="nombre_usuario"
                  multiple
                ></v-select>
                <label for="vendedores">Vendedor(es)</label>
                <span v-if="errores.vendedores" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.vendedores[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                placeholder="Escriba una observación..."
                id="observacion"
                v-model="formSubmit.observacion"
              >
                Observación
                <span
                  v-if="errores.observacion"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.observacion[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="row mt-2"
      v-for="(comprobanteAgrupado, index) in comprobantesAgrupados"
      :key="index + comprobanteAgrupado.title"
    >
      <div class="col-xs-12">
        <item-cierre-comisiones
          :permiteEditarComision="permiteEditarComision"
          @vendedorCambiado="consultar"
          :vendedores="vendedores"
          :index="index"
          :errores="errores"
          :saldo_anterior="obtenerSaldoAnterior(comprobantesAgrupados[index].vendedor_id)"
          :porcentaje_comision="formSubmit.porcentaje_comision"
          :comision_base="formSubmit.comision_base"
          v-model="comprobantesAgrupados[index]"
        ></item-cierre-comisiones>
      </div>
    </div>
    <div class="card mt-2">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>Margen total</th>
                    <th>Base</th>
                    <th>Porc. Comisión</th>
                    <th>Comisión total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{ moneyFormat(margenTotal) }}
                    </td>
                    <td>
                      {{ moneyFormat(formSubmit.comision_base) }}
                    </td>
                    <td>
                      {{ decimalFormat(formSubmit.porcentaje_comision) }}
                    </td>
                    <td>
                      {{ moneyFormat(comisionTotal) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    vendedoresIterables: function() {
      if (this.selectedVendedores.length > 0) return this.selectedVendedores;
      else return this.vendedores;
    },
    comisionTotal : function () {
      let comisionTotal = 0;
      for (let i = 0; i < this.comprobantesAgrupados.length; i++) {
        comisionTotal += parseFloat(this.comprobantesAgrupados[i].comision);
      }
      comisionTotal = round(comisionTotal);
      this.formSubmit.total_comision = comisionTotal;
      return comisionTotal;
    },
    margenTotal : function () {
      let margenTotal = 0;
      for (let i = 0; i < this.comprobantesAgrupados.length; i++) {
        margenTotal += parseFloat(this.comprobantesAgrupados[i].margen);
      }
      margenTotal = round(margenTotal);
      this.formSubmit.total_margenes = margenTotal;
      return margenTotal;
    }
  },
  props: {
    vendedores: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    porcentaje_comision: {
      type: Number,
      required: false,
      default: 0
    },
    comision_base: {
      type: Number,
      required: false,
      default: 0
    },
    permiteEditarComision : {
      type : Boolean,
      required : false,
      default : false
    }
  },
  data: function() {
    return {
      moneyFormat : moneyFormat,
      decimalFormat : decimalFormat,
      form: {
        fecha_inicial: moment(new Date()).format("YYYY-MM-DD"),
        fecha_final: moment(new Date()).format("YYYY-MM-DD"),
        vendedores: []
      },
      errores: {},
      selectedVendedores: [],
      comprobantes: [],
      comprobantesConsultados: false,
      comprobantesAgrupados: [],
      formSubmit: {
        observacion: "",
        vendedores: [],
        total_margenes: 0,
        total_base: 0,
        saldo_pendiente: 0,
        porcentaje_comision: 0,
        comision_base: 0,
        fecha_inicial :'',
        fecha_final : '',
        total_comision : 0
      },
      currentConciliacion: null
    };
  },
  methods: {
    obtenerSaldoAnterior : function (vendedorId) {
      for (let i = 0; i < this.vendedores.length; i++)
        if (this.vendedores[i].id == vendedorId) {
          return parseFloat(this.vendedores[i].saldo_anterior);
          break;
        }
      return 0;
    },
    cancelar: function() {
      this.errores = {};
      this.comprobantes.splice(0, this.comprobantes.length);
      this.comprobantesAgrupados.splice(0, this.comprobantesAgrupados.length);
      this.comprobantesConsultados = false;
    },
    agruparComprobantes: function() {
      this.comprobantesAgrupados.splice(0, this.comprobantesAgrupados.length);
      for (let i = 0; i < this.vendedoresIterables.length; i++) {
        let item = {
          title: this.vendedoresIterables[i].nombre_usuario,
          comprobantes: [],
          observacion: "",
          saldo: 0,
          comision: 0,
          margen: 0,
          vendedor_id : this.vendedoresIterables[i].id,
          saldo_anterior : this.vendedoresIterables[i].saldo_anterior
        };
        for (let j = 0; j < this.comprobantes.length; j++)
          if (
            this.comprobantes[j].vendedor_id == this.vendedoresIterables[i].id
          )
            item.comprobantes.push(this.comprobantes[j]);
        if (item.comprobantes.length > 0) this.comprobantesAgrupados.push(item);
      }
    },
    consultar: function() {
      let that = this;
      that.errores = {};
      axios
        .get(url + "/cierre-comisiones/consultar/conciliaciones", {
          params: this.form
        })
        .then(function(response) {
          that.comprobantes = response.data.comprobantes;
          that.currentConciliacion = response.data.conciliacion;
          if (that.currentConciliacion !== null) {
            that.formSubmit.comision_base =
              that.currentConciliacion.comision_base;
            that.formSubmit.porcentaje_comision =
              that.currentConciliacion.porcentaje_comision;
          } else {
            that.formSubmit.comision_base = that.comision_base;
            that.formSubmit.porcentaje_comision = that.porcentaje_comision;
          }
          that.comprobantesConsultados = true;
          that.agruparComprobantes();
        }).catch(function (error) {
          if (error && error.response) {
            let response = error.response;
            let status = response.status;
            if (status === 422)
            {
              that.errores = response.data.errors;
              swal('Hay errores en el formulario.', 'Aviso', 'warning');
              return;
            }
          }
          swal('Hubo un error, intente nuevamente.', 'Error', 'error');
        });
    },
    consultarCierres : function () {
        location.href = url + '/cierre-comisiones';
    },
    cerrar: function() {
      let that = this;
      if (that.margenTotal == 0) {
        swal('Se debe conciliar al menos un comprobante.', 'Aviso', 'warning');
        return;
      }
      swal({
          title: '¿Desea cerrar el período seleccionado?',
          text: "Si posteriormente se desea desconciliar los comprobantes, se tendrá que hacer desde la consulta de conciliaciones.",
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Cerrar',
          cancelButtonText : 'No'
      }).then((result) => {
        if (result.value){
          that.formSubmit.fecha_inicial = that.form.fecha_inicial;
          that.formSubmit.fecha_final = that.form.fecha_final;
          that.formSubmit.vendedores.splice(0, that.formSubmit.vendedores.length);
          for (let i = 0; i < that.comprobantesAgrupados.length; i++) {
            let item = {
              vendedor_id : that.comprobantesAgrupados[i].vendedor_id,
              comprobantes : [],
              observacion: that.comprobantesAgrupados[i].observacion,
              saldo: that.comprobantesAgrupados[i].saldo,
              comision: that.comprobantesAgrupados[i].comision,
              margen: that.comprobantesAgrupados[i].margen,
              saldo_anterior : that.comprobantesAgrupados[i].saldo_anterior
            };
            for (let j = 0; j < that.comprobantesAgrupados[i].comprobantes.length; j++) {
              item.comprobantes.push({
                comprobante_id : that.comprobantesAgrupados[i].comprobantes[j].id_comprobante,
                conciliado : that.comprobantesAgrupados[i].comprobantes[j].conciliado
              });
            }
            that.formSubmit.saldo_pendiente += parseFloat(that.comprobantesAgrupados[i].saldo);
            that.formSubmit.saldo_pendiente = round(that.formSubmit.saldo_pendiente);
            that.formSubmit.vendedores.push(item);
          }
          axios.post(url + '/cierre-comisiones', that.formSubmit).then(function () {
            swal('El período ha sido conciliado.', 'Realizado', 'success');
            setTimeout(function () {
              location.reload(true);
            }, 1000);
          }).catch(function (error) {
            if (error && error.response) {
              let response = error.response;
              let status = response.status;
              if (status === 422) {
                swal('El formulario tiene errores.', 'Aviso', 'warning');
                that.errores = response.data.errors;
                return;
              }
            }
            swal('Hubo un error, intente nuevamente.', 'Error', 'error');
          });
        }             
      });
    },
    inputVendedores: function() {
      this.form.vendedores.splice(0, this.form.vendedores.length);
      for (let i = 0; i < this.selectedVendedores.length; i++)
        this.form.vendedores.push(this.selectedVendedores[i].id);
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/cierre-comisiones/CierreComisiones.vue